module.exports = __webpack_public_path__ + "media/23.d78cbed4.mp3";